var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"property-table__item"},[_c('td',[_vm._v("\n    "+_vm._s(_vm.itemKey)+"\n  ")]),_c('td',[_vm._v("\n    "+_vm._s(_vm.itemValue)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }